<template>
  <b-form-input v-if="format==='String' && !readonly" class="ml-2"
                :class="withBorder ? '' : 'noBorder'"
                type="text" v-model="tempValue"
                placeholder="--"></b-form-input>

  <b-form-input v-else-if="format==='Integer' && !readonly" class="ml-2"
                :class="withBorder ? '' : 'noBorder'"
                type="number" v-model="tempValue"
                placeholder="--"></b-form-input>

  <b-form-checkbox v-else-if="format==='Boolean' && !readonly" class="ml-2 mt-2 mb-2"
                   type="checkbox"
                   v-model="tempValue"></b-form-checkbox>
  <div v-else-if="format==='Boolean'" class="text-style ml-2">
    {{ value ? '√' : 'x' }}
  </div>
  <div v-else class="text-style ml-2">
    {{ value }}
  </div>
</template>

<script>
export default {
  name: "InputForInspectTemplate",
  props: {
    format: {
      type: String,
      required: true
    },
    value: {
      required: true
    },
    readonly: {
      type: Boolean,
      default: false
    },
    withBorder: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      tempValue: null
    }
  },
  watch: {
    tempValue() {
      this.$emit('update:value', this.tempValue);
    },
    value: {
      handler() {
        this.tempValue = this.value;
      },
      immediate: true
    }
  }
}
</script>

<style scoped>
label {
  margin-bottom: 0 !important;
}

input[type="text"], [type="number"] {
  width: max-content !important;
  height: max-content !important;
  font-size: 1rem;
}

.noBorder {
  border: rgba(0, 0, 0, 0);
}

.text-style {
  font-size: 1rem;
  font-weight: bold;
}
</style>